let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("boQlV")).then(() => parcelRequire('dp3dj'));